import { buttonUnstyledClasses } from '@mui/base/ButtonUnstyled';
import TabPanelUnstyled from '@mui/base/TabPanelUnstyled';
import TabUnstyled, { tabUnstyledClasses } from '@mui/base/TabUnstyled';
import TabsListUnstyled from '@mui/base/TabsListUnstyled';
import TabsUnstyled from '@mui/base/TabsUnstyled';
import CodeIcon from '@mui/icons-material/Code';
import LanguageIcon from '@mui/icons-material/Language';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/system';
import * as React from 'react';
import awss from '../assetes/image/aws.jpg';
import database from '../assetes/image/databse.jpg';
import img from '../assetes/image/programming (2).jpg';
import tools from '../assetes/image/tools.jpg';
import Layout from '../component/Layout/Layout';
import Comfortable from '../component/Skill/Comfortable';
import Expertise from '../component/Skill/Expertise';
import Familiar from '../component/Skill/Familiar';
import Tools from '../component/Skill/Tools';
import ContentHeader from './ContentHeader';
const blue = {
  50: '#340691',
  200: '#29076b',
  400: '#200654',
  500: '#160538',
  900: '#12052b',
}
const Tab = styled(TabUnstyled)`
  font-family: IBM Plex Sans, sans-serif;
  color: ${blue[200]};
  background-color: "#D97D54"
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: bold;
  width: 80%;
  padding: 6px 10px;
  margin: 6px 6px;
  border: none;
  border-radius: 5px;
  display: flex;
  justify-content: center;

  &:hover {
    background-color: ${blue[200]};
    cursor: pointer;
  }

  &:focus {
    color: ${blue[500]};
    border-radius: 3px;
    outline: 2px solid #10B981;
    outline-offset: 2px;
  }
  &.${tabUnstyledClasses.root} {
    background-color: ${blue[900]};
    color: ${blue[600]};
  }
  
  &.${tabUnstyledClasses.selected} {
    background-color: ${blue[50]}!;
    color: ${blue[600]};
  }

  
  &.${buttonUnstyledClasses.disabled} {
    background-color: ${blue[600]};
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const TabPanel = styled(TabPanelUnstyled)`
  width: 100%;
  font-family: IBM Plex Sans, sans-serif;
  font-size: 0.875rem;
  margin: 10px 0;
`;
const TabsList = styled(TabsListUnstyled)`
  border-radius: 8px;
  margin-bottom: 16px;
  padding: 5px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  align-content: space-between;
  margin: 0 auto;
`;


function BasicCard({ name, imgs }) {
  return (
    <Box sx={{}}>
      {/* <CardMedia
        component="img"
        height="124"
        image={imgs}
        alt="Paella dish"
      /> */}
      this is image section
      <img src={imgs} alt='name' style={{height: "150px", width: '200px'}}/>
      <Box sx={{padding: '5px 5px'}}>
        <Typography variant='h6' color='secondary'>{name}</Typography>
      </Box>


    </Box>
  );
}
export default function Skill() {

  return (
    <div id="SKILL">
      <Layout>
        <div>
          <ContentHeader name={'My Skills'} />
        </div>
        <TabsUnstyled defaultValue={0}>
          <TabsList>
            <Tab icon={<LanguageIcon />} >
              <BasicCard name={'CLOUD TECHNOLOGIES'} imgs={awss} />
              {/* CLOUD TECHNOLOGIES */}
            </Tab>
            <Tab icon={<CodeIcon />}>
              <BasicCard name={' LANGUAGES & LIBRARY'} imgs={img} />

            </Tab>
            <Tab>
              <BasicCard name={'DATABASE MANAGEMENT'} imgs={database} />
            </Tab>
            <Tab>
              <BasicCard name={'DEVELOPMENT TOOLS'} imgs={tools} />

            </Tab>
          </TabsList>
          <TabPanel value={0}><Expertise /> </TabPanel>
          <TabPanel value={1}><Comfortable /> </TabPanel>
          <TabPanel value={2}><Familiar /> </TabPanel>
          <TabPanel value={3}><Tools /> </TabPanel>
        </TabsUnstyled>


      </Layout>
    </div>
  )
}
